{
  "title": "Grease",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level conjuration",
  "level": 1,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a bit of pork rind or butter)",
  "duration": "1 minute",
  "description": [
    "Slick grease covers the ground in a 10-foot square centered on a point within range and turns it into difficult terrain for the duration.",
    "When the grease appears, each creature standing in its area must succeed on a Dexterity saving throw or fall prone. A creature that enters the area or ends its turn there must also succeed on a Dexterity saving throw or fall prone."
  ],
  "spellLists": ["artificer", "sorcerer", "wizard"]
}
